import { IconCircleCheck } from '@tabler/icons-react'
import { FC, ReactNode, useCallback, useState } from 'react'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogTrigger,
} from '../../atoms/alert-dialog'
import { api } from 'src/api/root'

interface ApproveLayerDialogProps {
  fileId: string
  fileName: string
  children: ReactNode
}

const ApproveLayerDialog: FC<ApproveLayerDialogProps> = ({ fileId, fileName, children }) => {
  const [opened, setOpened] = useState(false)
  const { mutateAsync, isPending } = api.layer.approve.useMutation()

  const handleApprove = useCallback(async () => {
    try {
      await mutateAsync(fileId)
      setOpened(false)
    } catch (error) {
      console.log(error)
    }
  }, [mutateAsync, fileId])

  return (
    <AlertDialog open={opened} onOpenChange={setOpened}>
      <AlertDialogTrigger className="hover:cursor-pointer">{children}</AlertDialogTrigger>
      <AlertDialogContent>
        <div className="flex flex-col items-center gap-4">
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-light-green-500/20">
            <IconCircleCheck className="h-6 w-6 text-light-green-500" />
          </div>
          <div className="flex flex-col justify-center gap-6">
            <span className="text-center text-xl text-green-50">Mark layer as completed</span>
            <span className="text-center text-gray-50">
              Approving <span className="font-semibold text-white">{fileName}</span> makes it live across the platform:
              COPA can pick it during project creation, and users will see it in their projects. Make sure its{' '}
              <span className="font-semibold text-white">tier</span>,{' '}
              <span className="font-semibold text-white">country</span>, and{' '}
              <span className="font-semibold text-white">access</span> are configured before you continue.
            </span>
          </div>
        </div>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isPending} onClick={() => setOpened(false)} className="w-40">
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction disabled={isPending} onClick={handleApprove} className="w-40">
            Approve
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}

export default ApproveLayerDialog
